const userType = {
    NONE: 0, FAMILY: 1, EMPLOYEE: 2, ADMIN: 3
}
const loginType = {
    NA: 0, FIRSTTIME: 1, SECONDTIME: 2
};
const apiPath = process.env.API_PATH || 'https://testedopezinhoapi.fcm.unicamp.br' //'http://localhost:8000' 

export { userType, loginType, apiPath }
